import _pick from 'lodash/pick';
import { EnvironmentData, IWalkmePermission } from './types';
import { ADMIN_CONDITIONS, IEnvironment, ISystem, ROLES } from '@communication-center/data-objects';

export const parseSystem = (walkmeSystem: ISystem) => _pick(walkmeSystem, ['id', 'guid', 'systemTypeKey']);

export const parseEnvironment = (envrionment: EnvironmentData): IEnvironment => ({
    id: envrionment.Id.toString(),
    label: envrionment.Name,
    path: envrionment.Path
});

export const parseSystemData = (walkmeSystem: ISystem) => ({
    currentSystem: walkmeSystem?.guid,
    currentNumericSystemId: walkmeSystem?.id,
    currentSystemTypeKey: walkmeSystem?.systemTypeKey,
    walkmeFeatureFlags: walkmeSystem?.featureFlags?.map(it => it.flagName)
});

export const getCalculatedRole = (permissions: IWalkmePermission[] | undefined): string => {
    const adminRes = permissions?.every(
        per => !ADMIN_CONDITIONS[per?.actionKey] || (ADMIN_CONDITIONS[per?.actionKey] && per.permission === ADMIN_CONDITIONS[per?.actionKey])
    );
    return adminRes ? ROLES.ADMIN : ROLES.COMMUNICATOR;
};

export const loadWalkmeSnippet = () => {
    (function () {
        const walkme = document.createElement('script');
        walkme.type = 'text/javascript';
        walkme.async = true;
        walkme.src = 'https://cdn.walkme.com/users/2ec14a29526d411b819081d85b3eec27/walkme_2ec14a29526d411b819081d85b3eec27_https.js';
        const s = document.getElementsByTagName('script')[0];
        s && s.parentNode && s.parentNode.insertBefore(walkme, s);
        window['_walkmeConfig'] = { smartLoad: true };
    })();
};
